<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 只保留全局样式 */
:root {
  --primary-color: #00ffd5;
  --secondary-color: #7928ca;
  --text-color: #e4e4e4;
  --background-color: #0a0a0a;
  --accent-color: #ff0080;
  --card-bg: #1a1a1a;
  --gradient-1: #7928ca;
  --gradient-2: #ff0080;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
}
</style>
